import ChangeLanguageTemplate from '@components/templates/ChangeLanguageTemplate'
import { observer } from 'mobx-react'
import React from 'react'
import { useParams } from 'react-router-dom'

const ChangeLanguagePage = ({ history }) => {
  const { lang } = useParams()

  return (
    <ChangeLanguageTemplate
      type="changeLanguage"
      history={history}
      lang={lang}
    />
  )
}

export default observer(ChangeLanguagePage)
